__turbopack_context__.v({
  "menuButton": "menu-drawer-module__F1FMWq__menuButton",
  "menuIcon": "menu-drawer-module__F1FMWq__menuIcon",
  "menuList": "menu-drawer-module__F1FMWq__menuList",
  "wrapper": "menu-drawer-module__F1FMWq__wrapper",
});
